import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("كلمتا المرور غير متطابقتين"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      localStorage.removeItem("token");
      toast.success("تم تعيين كلمة المرور الجديدة، سجّل دخولك الآن");
      navigate("/login", { replace: true });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" dir="rtl">
      <Card className="w-full max-w-md p-8" data-testid="reset-password-card">
        {!token ? (
          <div className="text-center space-y-3" data-testid="reset-missing-token">
            <h1 className="font-heading text-xl font-extrabold">الرابط غير مكتمل</h1>
            <Link to="/forgot-password" className="text-primary font-semibold text-sm">اطلب رابطاً جديداً</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <ShieldCheck className="w-10 h-10 text-accent mb-3" />
              <h1 className="font-heading text-2xl font-extrabold">تعيين كلمة مرور جديدة</h1>
              <p className="text-sm text-muted-foreground mt-1">10 أحرف على الأقل، وتحتوي حروفاً وأرقاماً.</p>
            </div>
            <div>
              <Label className="mb-1.5 block">كلمة المرور الجديدة</Label>
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={10} autoComplete="new-password" data-testid="reset-new-password-input" />
            </div>
            <div>
              <Label className="mb-1.5 block">تأكيد كلمة المرور</Label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" data-testid="reset-confirm-password-input" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-xl h-11 gap-2" data-testid="reset-submit-btn">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} حفظ كلمة المرور
            </Button>
            <div className="text-center"><Link to="/forgot-password" className="text-sm text-muted-foreground hover:text-primary" data-testid="reset-request-new">انتهى الرابط؟ اطلب رابطاً جديداً</Link></div>
          </form>
        )}
      </Card>
    </div>
  );
}
